import { navigate } from "gatsby";

import { isRunTime } from "./isRunTime";

const redirectTo = (path, options = {}) => {
  if(isRunTime() && options?.native && options?.native === true) {
    return window.location.href = path;
  }

  return navigate(path, options);
};

const handleRefresh = () => {
  let path = '';
  if(isRunTime()) {
    path = window.location.pathname + window.location.search;
  }

  return redirectTo(path, { native: true });
}

/**
 * Opens a URL in a new tab with security best practices
 * @param {string} url - The URL to open
 * @returns {boolean} - True if the URL was opened successfully, false otherwise
 */
const openInNewTab = (url) => {
  // Early return if not in runtime
  if (!isRunTime()) {
    return false;
  }

  try {
    // Basic URL validation
    if (!url || url === '#' || url.trim() === '') {
      return false;
    }

    // Try to create a URL object to validate the URL
    let urlObject;
    try {
      urlObject = new URL(url);
    } catch (e) {
      // If URL is relative, prepend origin
      if (url.startsWith('/')) {
        urlObject = new URL(url, window.location.origin);
      } else {
        return false;
      }
    }

    // Security check for javascript: URLs
    if (urlObject.protocol === 'javascript:') {
      return false;
    }

    // Open URL with security attributes
    const newWindow = window.open(
      urlObject.href,
      '_blank',
      'noopener,noreferrer'
    );

    // Some browsers might block the popup
    if (newWindow === null) {
      return false;
    }

    // Add security attributes manually (fallback)
    newWindow.opener = null;

    return true;
  } catch (error) {
    console.error('Error opening new tab:', error);
    return false;
  }
};

export { redirectTo, handleRefresh, openInNewTab };